import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'

export default class BlockCarouselSit {
    constructor() {
        BlockCarouselSit.initSlider()
    }

    static async initSlider() {
        const blocks = '[data-element="wp-block-customer-carousel-sit"]'
        document.querySelectorAll(blocks).forEach(async (block) => {
            const slider = block.querySelectorAll(
                '[data-element="wp-block-customer-carousel-sit-slider"]',
            )[0]
            const next = block.querySelectorAll(
                '[data-element="wp-block-customer-carousel-sit-slider-navigation-next"]',
            )[0]
            const prev = block.querySelectorAll(
                '[data-element="wp-block-customer-carousel-sit-slider-navigation-prev"]',
            )[0]

            await Swiper.create(slider, {
                mousewheel: {
                    forceToAxis: true,
                },
                navigation: {
                    nextEl: next,
                    prevEl: prev,
                },
                keyboard: false,
                spaceBetween: 20,
                slidesPerView: 1.05,
                lazy: true,
                loop: true,
                speed: 500,
                watchSlidesProgress: true,
                mousewheelControl: false,
                preventClicksPropagation: false,
                breakpoints: {
                    651: {
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    1001: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                    1456: {
                        slidesPerView: 3,
                        spaceBetween: 40,
                    },
                },
            })
        })
    }
}

new BlockCarouselSit()
